import { IStatusObjectModel, IMergedStatusObjectModel } from "./status-object-model.interface";
import { TranslateObject } from "./translate-object.interface";

export enum StepState {
    NotStarted = "notStarted",
    Active = "active",
    Completed = "completed",
    All = "all",
}

export const StatePriority: Record<StepState, number> = {
    [StepState.NotStarted]: 0,
    [StepState.Active]: 1,
    [StepState.Completed]: 2,
    [StepState.All]: 3,
};

export interface IStepsModel {
    Name: TranslateObject;
    Order: number;
    State: StepState;
    Id: string;
    Statuses: IStatusObjectModel[];
    Disabled?: boolean; // This is apparently not returned by the service, but present in the back-end code.
}

export interface IMergedStepsModel {
    Id: string;
    Name: TranslateObject;
    Order: number;
    State: StepState;
    Statuses: IMergedStatusObjectModel[];
    Disabled?: boolean;
}
